export default __webpack_public_path__ + "static/media/power5.5677e52e.svg";